export function validarRutCompleto(value) {
  // Valida que el valor ingresado tenga un formato de 11.111.111-1
  return /^(\d{1,2}(?:\.\d{3}){2}-[\dkK]{1})$/g.test(value) ? true : false;
}

export function validarRutSoloGuion(value) {
  // Valida que el valor ingresado tenga un formato de 11111111-1
  return /^(\d{7,8}-[\dkK]{1}$)/g.test(value) ? true : false;
}

export function validarRutJunto(value) {
  const auxRut = value
    .split('-')[0]
    .split('.')
    .join('');
  const dv = value.split('-')[1];

  var rut = parseInt(auxRut),
    M = 0,
    S = 1;
  var correctDV;
  for (; rut; rut = Math.floor(rut / 10)) S = (S + (rut % 10) * (9 - (M++ % 6))) % 11;
  correctDV = S ? S - 1 : 'k';

  return String(dv.toLowerCase()) === String(correctDV) ? true : false;
}

export function validarRutSeparado(run, dv) {
  var rut = parseInt(run.split('.').join('')),
    M = 0,
    S = 1;
  var correctDV;
  for (; rut; rut = Math.floor(rut / 10)) S = (S + (rut % 10) * (9 - (M++ % 6))) % 11;
  correctDV = S ? S - 1 : 'k';

  return String(dv.toLowerCase()) === String(correctDV) ? true : false;
}

export function validarMail(value) {
  if (/^[\d\D]+@[\d\D]+\.[\d\D]+$/g.test(value)) {
    return true;
  }
  return false;
}
